import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// import p1 from 'assests/Photos/classassembly.jpg';
// import p2 from 'assests/Photos/EventsandActivities/Association.jpg';
// import p3 from 'assests/Photos/extraciricular.jpg';
// import p4 from 'assests/Photos/knowmore/lifeskill/l11.jpg';
// import p5 from 'assests/Photos/schoolprogram.jpg';
// import p6 from 'assests/Photos/knowmore/lifeskill/l2.jpg';

const Team = () => {

  const [config, setConfig] = useState({ base_image_url: '' });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  useEffect(() => {
    fetch('/config.json') // This resolves to /config.json in the static folder
      .then((response) => response.json())
      .then((data) => setConfig(data))
      .catch((error) => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/classassembly.webp`;
  const p2 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/Association.webp`;
  const p3 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/extraciricular.webp`;
  const p4 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/sewa.webp`;
  const p5 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/schoolprogram.webp`;
  const p6 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/lifeskill.webp`;
  const p7 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/CLUB.webp`;
  const p8 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/Preprimary.webp`;
  const p9 = `${config.base_image_url}/home/home-static/static-images/OUR_EVENTS_AND_ACTIVITES/Triumphs.webp`;




  const mock = [
    {
      media: p3,
      title: 'Co-Scholastic Activities',
      subtitle:
        '',
      href: '/field-trip-class-7',
    },
    // {
    //   media: p6,
    //   title: 'Student Corner',
    //   subtitle:
    //     '',
    //     href:'/student-cornor',
    // },
    {
      media: p6,
      title: 'Life Skill',
      subtitle:
        '',
      href: '/career-guidance-program-2026',
    },
    // {
    //   media: p2,
    //   title: 'CCA/Association Activities',
    //   subtitle:
    //     '',
    //   href:'/clubs',
    // },
    {
      media: p7,
      title: 'Clubs',
      subtitle:
        '',
      href: '/clubss',
    },
    {
      media: p2,
      title: 'Association',
      subtitle:
        '',
      href: '/association',
    },
    {
      media: p5,
      title: 'School Programs',
      subtitle:
        '',
      href: '/investiture-ceremony-2026'
    },
    {
      media: p1,
      title: 'Class Assembly',
      subtitle:
        '',
      href: '/class-assembly-12-a-2026'
    },
    {
      media: p4,
      title: 'SEWA',
      subtitle:
        '',
      href: '/ayurveda-2026'
    },
     {
      media: p8,
      title: 'Early Years Panorama',
      subtitle:
        '',
      href: '/environment-day-celebration-2026'
    },
     {
      media: p9,
      title: 'Trail of Triumphs',
      subtitle:
        'National level achievements',
      href: '/trailblazer'
    }
    
  ];


  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const sliderOpts = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: isMd ? 3 : 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
  };

  return (
    <Box>
      <Typography fontWeight={700} variant={'h4'} align={'center'} id='activities'>
        Learning Landscape & Trail of Triumphs 
      </Typography>
      <Box
        data-aos={'fade-up'}
        maxWidth={{ xs: 420, sm: 620, md: 1 }}
        margin={'0 auto'}
      >
        <Slider {...sliderOpts}>
          {mock.map((item, i) => (
            <Box key={i} padding={{ xs: 1, md: 2, lg: 3 }}>
              <Box
                display={'block'}
                width={1}
                height={1}
                boxShadow={0}
                variant={'outlined'}
                bgcolor={'alternate.main'}
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
                sx={{
                  textDecoration: '',
                  transition: 'all .2s ease-in-out',
                  '&:hover': {
                    transform: `translateY(-${theme.spacing(1 / 2)})`,
                  },
                }}
              >
                
                  <Box
                    component={Card}
                    width={1}
                    height={1}
                    display={'flex'}
                    flexDirection={'column'}
                    sx={{ backgroundImage: 'none' }}
                  >
                    <a href={item.href} style={{ textDecoration: 'none', color: 'black' }}>
                    <CardMedia

                      image={item.media}

                      sx={{
                        position: 'relative',
                        height: { xs: 240, sm: 340, md: 280 },
                        overflow: 'hidden',
                      }}

                    >

                    </CardMedia>
                    
                    <CardContent>

                      <Typography
                        variant={'h6'}
                        gutterBottom
                        align={'left'}
                        sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      {hoveredIndex === i && item.subtitle && (
                        <Typography
                          variant={'body2'}
                          align={'left'}
                          sx={{ fontWeight: 500, color: 'text.secondary' }}>
                          {item.subtitle}
                        </Typography>
                      )}
                    </CardContent>
                    </a>
                    <Box flexGrow={1} />
                    {/* <CardActions sx={{ justifyContent: 'flex-end' }} >
                  
                  <Button
                    size={'large'}
                    sx={{ marginTop: 2 }}
                    href={item.href}
                    endIcon={
                      <Box
                        component={'svg'}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        width={24}
                        height={24}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </Box>
                    }
                  >                   
                    Know more
                  </Button>
                  </CardActions> */}
                  </Box>
              </Box>
            
            </Box>
            
          ))}
    </Slider>
      </Box >
    </Box >
  );
};

export default Team;


